import React from 'react';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { isBeyondUnlocked, triggerEvent } from '../helpers/global.js';

import '../sass/components/SidebarView.scss';

const ICONS = {
  overview: <svg width='19' height='18' viewBox='0 0 19 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M16.5 0H2.5C1.4 0 0.5 0.9 0.5 2V16C0.5 17.1 1.4 18 2.5 18H16.5C17.6 18 18.5 17.1 18.5 16V2C18.5 0.9 17.6 0 16.5 0ZM2.5 16V2H8.5V16H2.5ZM16.5 16H10.5V9H16.5V16ZM16.5 7H10.5V2H16.5V7Z'/>
  </svg>,
  beyond: <svg width='19' height='20' viewBox='0 0 19 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M17 1.5L15.5 0L14 1.5L12.5 0L11 1.5L9.5 0L8 1.5L6.5 0L5 1.5L3.5 0L2 1.5L0.5 0V20L2 18.5L3.5 20L5 18.5L6.5 20L8 18.5L9.5 20L11 18.5L12.5 20L14 18.5L15.5 20L17 18.5L18.5 20V0L17 1.5ZM16.5 17.09H2.5V2.91H16.5V17.09ZM3.5 13H15.5V15H3.5V13ZM3.5 9H15.5V11H3.5V9ZM3.5 5H15.5V7H3.5V5Z'/>
  </svg>,
  feedback: <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M20.49 2C20.49 0.9 19.6 0 18.5 0H2.5C1.4 0 0.5 0.9 0.5 2V14C0.5 15.1 1.4 16 2.5 16H16.5L20.5 20L20.49 2ZM18.5 2V15.17L17.33 14H2.5V2H18.5Z'/>
  </svg>,
  list: <svg width='21' height='18' viewBox='0 0 21 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M20.4 5.89L19.35 1.52C19.13 0.62 18.35 0 17.44 0H3.55001C2.65001 0 1.86001 0.63 1.65001 1.52L0.600007 5.89C0.360007 6.91 0.580007 7.95 1.22001 8.77C1.30001 8.88 1.41001 8.96 1.50001 9.06V16C1.50001 17.1 2.40001 18 3.50001 18H17.5C18.6 18 19.5 17.1 19.5 16V9.06C19.59 8.97 19.7 8.88 19.78 8.78C20.42 7.96 20.65 6.91 20.4 5.89ZM17.41 1.99L18.46 6.36C18.56 6.78 18.47 7.2 18.21 7.53C18.07 7.71 17.77 8 17.27 8C16.66 8 16.13 7.51 16.06 6.86L15.48 2L17.41 1.99ZM11.5 2H13.46L14 6.52C14.05 6.91 13.93 7.3 13.67 7.59C13.45 7.85 13.13 8 12.72 8C12.05 8 11.5 7.41 11.5 6.69V2ZM6.99001 6.52L7.54001 2H9.50001V6.69C9.50001 7.41 8.95001 8 8.21001 8C7.87001 8 7.56001 7.85 7.32001 7.59C7.07001 7.3 6.95001 6.91 6.99001 6.52ZM2.54001 6.36L3.55001 2H5.52001L4.94001 6.86C4.86001 7.51 4.34001 8 3.73001 8C3.24001 8 2.93001 7.71 2.80001 7.53C2.53001 7.21 2.44001 6.78 2.54001 6.36ZM3.50001 16V9.97C3.58001 9.98 3.65001 10 3.73001 10C4.60001 10 5.39001 9.64 5.97001 9.05C6.57001 9.65 7.37001 10 8.28001 10C9.15001 10 9.93001 9.64 10.51 9.07C11.1 9.64 11.9 10 12.8 10C13.64 10 14.44 9.65 15.04 9.05C15.62 9.64 16.41 10 17.28 10C17.36 10 17.43 9.98 17.51 9.97V16H3.50001Z'/>
  </svg>,
  edit: <svg width='19' height='18' viewBox='0 0 19 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M11.56 6.02L12.48 6.94L3.42 16H2.5V15.08L11.56 6.02ZM15.16 0C14.91 0 14.65 0.1 14.46 0.29L12.63 2.12L16.38 5.87L18.21 4.04C18.6 3.65 18.6 3.02 18.21 2.63L15.87 0.29C15.67 0.09 15.42 0 15.16 0ZM11.56 3.19L0.5 14.25V18H4.25L15.31 6.94L11.56 3.19Z'/>
  </svg>,
  add: <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M11.5 5H9.5V9H5.5V11H9.5V15H11.5V11H15.5V9H11.5V5ZM10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 18C6.09 18 2.5 14.41 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 14.41 14.91 18 10.5 18Z'/>
  </svg>,
  settings: <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M17.5 10C17.5 9.77 17.49 9.55 17.47 9.32L19.33 7.91C19.73 7.61 19.84 7.05 19.59 6.61L17.72 3.38C17.47 2.94 16.93 2.76 16.47 2.96L14.32 3.87C13.95 3.61 13.56 3.38 13.15 3.19L12.86 0.88C12.8 0.38 12.37 0 11.87 0H8.13997C7.62997 0 7.19997 0.38 7.13997 0.88L6.84997 3.19C6.43997 3.38 6.04997 3.61 5.67997 3.87L3.52997 2.96C3.06997 2.76 2.52997 2.94 2.27997 3.38L0.40997 6.62C0.15997 7.06 0.26997 7.61 0.66997 7.92L2.52997 9.33C2.50997 9.55 2.49997 9.77 2.49997 10C2.49997 10.23 2.50997 10.45 2.52997 10.68L0.66997 12.09C0.26997 12.39 0.15997 12.95 0.40997 13.39L2.27997 16.62C2.52997 17.06 3.06997 17.24 3.52997 17.04L5.67997 16.13C6.04997 16.39 6.43997 16.62 6.84997 16.81L7.13997 19.12C7.19997 19.62 7.62997 20 8.12997 20H11.86C12.36 20 12.79 19.62 12.85 19.12L13.14 16.81C13.55 16.62 13.94 16.39 14.31 16.13L16.46 17.04C16.92 17.24 17.46 17.06 17.71 16.62L19.58 13.39C19.83 12.95 19.72 12.4 19.32 12.09L17.46 10.68C17.49 10.45 17.5 10.23 17.5 10ZM10.04 13.5C8.10997 13.5 6.53997 11.93 6.53997 10C6.53997 8.07 8.10997 6.5 10.04 6.5C11.97 6.5 13.54 8.07 13.54 10C13.54 11.93 11.97 13.5 10.04 13.5Z'/>
  </svg>,
  claim_voucher: <svg width='21' height='16' viewBox='0 0 21 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M20.5 6V2C20.5 0.89 19.6 0 18.5 0H2.5C1.4 0 0.51 0.89 0.51 2V6C1.61 6 2.5 6.9 2.5 8C2.5 9.1 1.61 10 0.5 10V14C0.5 15.1 1.4 16 2.5 16H18.5C19.6 16 20.5 15.1 20.5 14V10C19.4 10 18.5 9.1 18.5 8C18.5 6.9 19.4 6 20.5 6ZM18.5 4.54C17.31 5.23 16.5 6.53 16.5 8C16.5 9.47 17.31 10.77 18.5 11.46V14H2.5V11.46C3.69 10.77 4.5 9.47 4.5 8C4.5 6.52 3.7 5.23 2.51 4.54L2.5 2H18.5V4.54ZM9.5 11H11.5V13H9.5V11ZM9.5 7H11.5V9H9.5V7ZM9.5 3H11.5V5H9.5V3Z'/>
  </svg>,
};

const mapStoreToProps = (store) => ({
  user: store.data.user,
  venues: store.data.venues || [],
});

class SidebarView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openedSections: [],
    };
  }

  onGetHelp = () => {
    triggerEvent('logAmplitude', 'Get Help');
    window.open('https://help.burpple.com/hc/en-us', '_blank');
  }

  onContainerClick = (e) => {
    if (e.target === e.currentTarget && this.props.onClose) {
      this.props.onClose()
    }
  }

  onNavClick = (key) => {
    if (key === 'add') {
      this.props.history.push('/venues/create');
    } else if (key === 'edit') {
      const venues = this.props.user.venues || [];
      const selected = this.props.venues;
      if (selected[0]) {
        this.props.history.push(`/venues/${selected[0]}`);
      } else if (venues[0]) {
        this.props.history.push(`/venues/${venues[0].id}`);
      } else {
        this.props.history.push('/venues');
      }
    } else if (key === 'list') {
      this.props.history.push('/venues');
    } else {
      this.props.history.push(`/${key}`);
    }
  }

  checkNavSelected = (key) => {
    const parts = this.props.location.pathname.split('/');
    const page = parts[1];
    const param = parts[2];
    if (key === 'edit') {
      return page === 'venues' && param && param !== 'create';
    } else if (key === 'add') {
      return page === 'venues' && param === 'create';
    } else if (key === 'list') {
      return page === 'venues' && !param;
    } else {
      return key === page;
    }
  }

  renderNavButton = (key, title, locked = false, disabled = false) => {
    return (
      <div
        className={classnames('sidebarButton ovewrview', {
          'locked': locked,
          'disabled': disabled,
          'selected': this.checkNavSelected(key),
        })}
        onClick={disabled ? null : () => this.onNavClick(key)}
      >
        <div className='buttonIcon'>{ICONS[key]}</div>
        {title}
      </div>
    )
  }

  render = ()  => {
    const beyond = isBeyondUnlocked(this.props.user, this.props.venues);
    const venues = this.props.user?.venues || [];
    return (
      <div
        className={classnames({
          'sidebarView': true,
          'customScrollBar': true,
          'open': this.props.open
        })}
        onClick={this.onContainerClick}
      >
        <div className='sidebarContainer'>
          <div className='menuList'>
            <div className='sidebarSection'>
              <div className='sectionTitle'>Dashboard</div>
              {this.renderNavButton('overview', 'Overview')}
              {this.renderNavButton('beyond', 'Beyond', !beyond)}
              {this.renderNavButton('feedback', 'Feedback', !beyond)}
            </div>
            {venues.length > 0 ?
              <div className='sidebarSection'>
                <div className='sectionTitle'>Tools</div>
                {this.renderNavButton('claim_voucher', 'Claim a voucher', false, true)}
              </div>
            : null}
            <div className='sidebarSection'>
              <div className='sectionTitle'>Listing</div>
              {this.renderNavButton('list', 'View listing')}
              {this.renderNavButton('edit', 'Edit listing')}
              {/*this.renderNavButton('add', 'Add an outlet')*/}
            </div>
            <div className='sidebarSection'>
              {this.renderNavButton('settings', 'Settings')}
            </div>
          </div>
          <div className='bottomControls'>
            <button onClick={this.onGetHelp}>Get help</button>
            <button
              className='outline'
              onClick={this.props.onLogout}
            >Logout</button>
          </div>
        </div>
      </div>
    )
  }

}

export default connect(mapStoreToProps)(withRouter(SidebarView));
